export { default } from './multiple-system-link';
